import { SUGGESTIONS_SUCCESS } from "./const";

function action(suggestions) {
  return {
    type: SUGGESTIONS_SUCCESS,
    suggestions,
  };
}

export default action;
